import axios from "axios";
import { baseUrl } from "../../common/config";

export const validateEmailParticipant = (id) =>
  axios({
    url: `${baseUrl}/api/participant/confirm-welcome?participantProfileId=${id}`,
    method: "POST",
  });

export const confirmAssessmentVideo = (participantProfileId) =>
  axios({
    url: `${baseUrl}/api/participant/confirm-onboarding-assessment-video?participantProfileId=${participantProfileId}`,
    method: "POST",
  });

export const getAssessment = (participantProfileId) =>
  axios.get(
    `${baseUrl}/api/assessments?participantProfileId=${participantProfileId}`
  );

export const storeAssessmentAnswer = ({
  participantProfileId,
  questionId,
  answerId,
}) =>
  axios.post(
    `${baseUrl}/api/assessments/questions/answers?participantProfileId=${participantProfileId}`,
    { questionId, answerId }
  );

export const finishAssessment = (participantProfileId) =>
  axios.post(
    `${baseUrl}/api/assessments/complete?participantProfileId=${participantProfileId}`
  );

export const getAssasmentsResult = async (participantProfileId) =>
  axios.get(
    `${baseUrl}/api/assessments/score?participantProfileId=${participantProfileId}`
  );

export const retakeAssessmentService = async ({ id }) => {
  try {
    const response = await axios({
      url: `${baseUrl}/api/assessments/restart?participantProfileId=${id}`,
      method: "POST",
    });

    return response;
  } catch (e) {
    return e;
  }
};

export const getAssasmentsFocusAll = async () =>
  axios.get(`${baseUrl}/api/assessments/focus/all`);
